import React from "react";

const ContactMap = () => {
  return (
    <div className="map_section">
      <div id="map">
        <iframe
          title="template google map"
          src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3661.160293862516!2d72.97313737601613!3d23.418576101433004!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x395dc5e0c676f08f%3A0x4d470c534cd8a4b2!2sGREECO%20PLAST%20PRIVATE%20LIMITED!5e0!3m2!1sen!2sin!4v1732518605521!5m2!1sen!2sin"
          allowfullscreen
        ></iframe>
      </div>
    </div>
  );
};

export default ContactMap;
